/** 用户刚登出标记（sessionStorage），阻止冷启动 / 缓存恢复误登录 */
export const SESSION_JUST_LOGGED_OUT_KEY = "edgen_just_logged_out";

/**
 * 写入登出标记。
 *
 * 必须在 token / 业务缓存全部清完后调用：`initFromCache()` 与
 * `syncAuthSessionFromSharedStorage()` 都靠这个标记熔断"刚登出又被缓存恢复"，
 * 尤其是 App 多 WebView 场景下原生注入脚本可能回灌其它 Tab 的 localStorage。
 */
export function markJustLoggedOut(): void {
  try {
    sessionStorage.setItem(SESSION_JUST_LOGGED_OUT_KEY, "true");
  } catch {
    // sessionStorage 不可用（隐私模式 / SSR）：忽略
  }
}

export function hasJustLoggedOutFlag(): boolean {
  try {
    return sessionStorage.getItem(SESSION_JUST_LOGGED_OUT_KEY) === "true";
  } catch {
    return false;
  }
}

/** 登录页稳定后清除登出标记，避免影响同 tab 后续正常冷启动恢复 */
export function clearJustLoggedOutFlag(): void {
  try {
    sessionStorage.removeItem(SESSION_JUST_LOGGED_OUT_KEY);
  } catch {
    // sessionStorage 不可用：忽略
  }
}
